export default {
  install (Vue) {
    Vue.mixin({
      methods: {
        async validateForm (form) {
          return await this.$refs[form].validate()
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js